import React from "react";

function TabPublisher() {
  return (
    <>
      <div className="container-fluid" id="tab-publisher-section">
        <ul className="row nav nav-pills mb-3" role="tablist">
          <li className="col-12 col-sm-6 col-lg-3 px-0 pt-1 pt-sm-0 px-sm-1  nav-item ">
            <a
              className="nav-link active border border-1"
              id="list-publisher-tab"
              data-toggle="pill"
              href="#list-publisher"
              role="tab"
              aria-controls="list-publisher"
              aria-selected="true"
            >
              <div className="d-flex flex-column  text-center ">
                <span>
                  <img
                    className="w-50"
                    src="/assets/img/list-site-publisher.svg"
                  />
                </span>
                <span class="text-dark">لیست نمایش دهندگان</span>
              </div>
            </a>
          </li>
          <li className="col-12 col-sm-6 col-lg-3 px-0 pt-1 pt-sm-0 px-sm-1  nav-item">
            <a
              className="nav-link border border-1"
              id="group-publisher-tab"
              data-toggle="pill"
              href="#group-publisher"
              role="tab"
              aria-controls="group-publisher"
              // aria-controls="display-report-positions"
              aria-selected="false"
            >
              <div className="d-flex flex-column text-center ">
                <span>
                  <img
                    className="w-50"
                    src="/assets/img/group-site-publisher.svg"
                  />
                </span>
                <span class="text-dark"> گروه نمایش دهندگان</span>
              </div>
            </a>
          </li>
          <li className="col-12 col-sm-6 col-lg-3 px-0 pt-1 pt-sm-0 px-sm-1  nav-item">
            <a
              className="nav-link border border-1"
              id="display-report-positions-tab"
              data-toggle="pill"
              href="#group-report-positions"
              role="tab"
              aria-controls="display-report-positions"
              aria-selected="false"
            >
              <div className="d-flex flex-column text-center ">
                <span>
                  <img
                    className="w-50"
                    src="/assets/img/report-positions-reserver.svg"
                  />
                </span>
                <span class="text-dark">بررسی رزرواسیون جایگاه ها</span>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </>
  );
}

export default TabPublisher;
